"use strict";

angular.module("admin")
	.controller("AdminActionLogsCtrl", ["$scope", "$uibModal", "toastr", "AdminActionLogsService", "ActionLogValueFormatter", "ACTION_LOG_TYPE_LABELS", "actionTypes", "clients",
		function ($scope, $uibModal, toastr, AdminActionLogsService, ActionLogValueFormatter, ACTION_LOG_TYPE_LABELS, actionTypes, clients) {

			function roundToMinute(date) {
				date.setSeconds(0, 0);
				return date;
			}

			function defaultCriteria() {
				const to = roundToMinute(new Date());
				const from = new Date(to.getTime());
				from.setDate(from.getDate() - 7);
				return {
					from: from,
					to: to,
					toIsNow: true,
					actionTypes: [],
					operator: "",
					organisation: undefined,
					search: ""
				};
			}

			function translateActionType(code, fallbackLabel) {
				return ACTION_LOG_TYPE_LABELS[code] || fallbackLabel || code;
			}

			const translatedActionTypes = actionTypes.data
				.map((actionType) => angular.extend({}, actionType, {label: translateActionType(actionType.code, actionType.label)}))
				.sort((a, b) => a.label.localeCompare(b.label, "fr"));

			const actionTypesByCode = {};
			translatedActionTypes.forEach((actionType) => {
				actionTypesByCode[actionType.code] = actionType;
			});

			$scope.data = {
				actionTypes: translatedActionTypes,
				organisations: clients.data,
				criteria: defaultCriteria(),
				logs: [],
				searched: false,
				loading: false,
				selectedLog: undefined
			};

			$scope.hasSearchCriterion = function () {
				const criteria = $scope.data.criteria;
				return criteria.actionTypes.length > 0
					|| !!(criteria.operator && criteria.operator.trim())
					|| !!criteria.organisation;
			};

			$scope.canSearchText = function () {
				return !!$scope.data.criteria.organisation;
			};

			$scope.$watch("data.criteria.organisation", (organisation) => {
				if (!organisation) {
					$scope.data.criteria.search = "";
				}
			});

			$scope.isPeriodValid = function () {
				const criteria = $scope.data.criteria;
				return !!criteria.from && !!criteria.to && criteria.from <= criteria.to;
			};

			$scope.canSearch = function () {
				return $scope.isPeriodValid() && $scope.hasSearchCriterion() && !$scope.data.loading;
			};

			$scope.onEndDateChange = function () {
				$scope.data.criteria.toIsNow = false;
			};

			$scope.search = function () {
				const criteria = $scope.data.criteria;
				const now = new Date();
				if (criteria.toIsNow) {
					criteria.to = roundToMinute(new Date(now.getTime()));
				}
				if (!$scope.canSearch()) {
					return;
				}
				$scope.data.loading = true;
				AdminActionLogsService.searchActionLogs({
					from: criteria.from,
					to: criteria.toIsNow ? now : criteria.to,
					actionTypes: criteria.actionTypes.map((actionType) => actionType.code),
					operator: criteria.operator ? criteria.operator.trim() : undefined,
					organisationId: criteria.organisation ? criteria.organisation.name : undefined,
					search: $scope.canSearchText() && criteria.search ? criteria.search.trim() : undefined
				})
					.then((response) => {
						$scope.data.logs = response.data;
						$scope.data.searched = true;
					})
					.catch((response) => {
						toastr.error(buildErrorMessage("Problème lors de la recherche dans l'historique des actions", response), "Erreur");
					})
					.finally(() => {
						$scope.data.loading = false;
					});
			};

			$scope.reset = function () {
				$scope.data.criteria = defaultCriteria();
				$scope.data.logs = [];
				$scope.data.searched = false;
			};

			const DATA_SOURCE_BADGES = {
				REALTIME: {label: "Temps réel", cssClass: "label-success"},
				THEORETICAL: {label: "Théorique", cssClass: "label-primary"}
			};

			$scope.getDataSourceBadge = function (log) {
				return log ? DATA_SOURCE_BADGES[log.dataSource] : undefined;
			};

			$scope.getActionTypeLabel = function (code) {
				return actionTypesByCode[code] ? actionTypesByCode[code].label : translateActionType(code);
			};

			$scope.getEntityType = function (code) {
				return actionTypesByCode[code] ? actionTypesByCode[code].entityType : "";
			};

			$scope.getOperatorLabel = function (operator) {
				if (!operator) {
					return "";
				}
				const label = angular.isString(operator) ? operator : (operator.name || operator.userName || "");
				return String(label).toLowerCase();
			};

			$scope.getOrganisationLabel = function (organisation) {
				if (!organisation) {
					return "";
				}
				const label = angular.isString(organisation) ? organisation : (organisation.name || organisation.id || "");
				return String(label).toLowerCase();
			};

			function buildDetailView(log) {
				const metadata = log.metadata || {};
				return {
					showMetadata: false,
					metadata: Object.keys(metadata).map((key) => ({
						key: key,
						display: ActionLogValueFormatter.format(metadata[key])
					})),
					changes: (log.changes || []).map((change) => ({
						field: change.field,
						oldDisplay: ActionLogValueFormatter.isEmpty(change.oldValue) ? null : ActionLogValueFormatter.format(change.oldValue),
						newDisplay: ActionLogValueFormatter.isEmpty(change.newValue) ? null : ActionLogValueFormatter.format(change.newValue)
					}))
				};
			}

			$scope.openDetailModal = function (log) {
				AdminActionLogsService.getActionLog(log.id)
					.then((response) => {
						const detail = response.data;
						Object.keys(log).forEach((key) => {
							if (detail[key] === null || detail[key] === undefined) {
								detail[key] = log[key];
							}
						});
						$scope.data.selectedLog = detail;
						$scope.data.selectedLogView = buildDetailView(detail);
						$uibModal.open({
							templateUrl: "actionLogDetailModal.html",
							scope: $scope,
							size: "lg",
							windowClass: "action-log-detail-modal"
						});
					})
					.catch((response) => {
						toastr.error(buildErrorMessage("Problème lors de la récupération du détail de l'action", response), "Erreur");
					});
			};

			function buildErrorMessage(message, response) {
				if (response && response.data && response.data.message) {
					return message + " " + response.data.message;
				}
				return message;
			}
		}
	]);
